import { config } from "../env";
import { get, getBlob, patch, post } from "./helpers/http-handler";

export const getAllGL = (queryRequest: string) =>
  get(`${config.API_URL}/gl?${queryRequest}`);

export const getSpecificGL = (id: string) =>
  get(`${config.API_URL}/gl/${id}`);

export const getGLImportTemplate = () =>
  getBlob(`${config.API_URL}/gl/import/template`);

export const createGL = (payload: object) =>
  post(`${config.API_URL}/gl`, payload);

export const updateGL = (id: string, payload: object) =>
  patch(`${config.API_URL}/gl/${id}`, payload);

export const updateGLBulk = (payload: object) =>
  patch(`${config.API_URL}/gl/bulk/active-inactive`, payload);
